import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '../views/Layouts/index.vue'
import { h, resolveComponent } from 'vue'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Layout,
    redirect: '/login',
    children: [
      {
        path: '/teacher/list',
        name: 'List',
        meta: {
          title: '本班学生',
          icon: 'Memo',
          type: 1,
        },
        component: () => import('../views/teacher/list.vue'),
      },
      {
        path: '/teacher/jobList',
        name: 'JobList',
        meta: {
          title: '作业管理',
          icon: 'Memo',
          type: 1,
        },
        component: () => import('../views/teacher/jobList.vue'),
      },
      {
        path: '/school/userList',
        name: 'UserList',
        meta: {
          title: '学员管理',
          type: 2,
        },
        component: () => import('../views/school/userList.vue'),
      },
      {
        path: '/school/tList',
        name: 'TList',
        meta: {
          title: '教师管理',
          type: 2,
        },
        component: () => import('../views/school/tList.vue'),
      },
      {
        path: '/school/classList',
        name: 'ClassList',
        meta: {
          title: '班级管理',
          type: 2,
        },
        component: () => import('../views/school/classList.vue'),
      },
      {
        path: '/school/personList/:id/:name',
        name: 'PersonList',
        meta: {
          title: '学员列表',
        },
        component: () => import('../views/school/personList.vue'),
      },
      // {
      //   path: '/school/vvip',
      //   name: 'Vvip',
      //   meta: {
      //     title: 'VVIP管理',
      //     type: 2,
      //   },
      //   component: () => import('../views/school/vvip.vue'),
      // },
    ],
  },
  {
    path: '/student/home',
    name: 'SHome',
    meta: {
      title: '',
      icon: 'Memo',
    },
    component: () => import('../views/student/home.vue'),
  },
  {
    path: '/teacher/home',
    name: 'Home',
    meta: {
      title: '',
      icon: 'Memo',
    },
    component: () => import('../views/teacher/home.vue'),
  },

  {
    path: '/login/:gid?/:type?',
    name: 'Login',
    meta: {
      title: '登录页',
    },
    component: () => import('../views/login.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
